import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import style from './index.css';

class GoHome extends PureComponent {
    static propTypes = {
        onClick: PropTypes.func,
        styles: PropTypes.object,
    };

    render() {
        const { styles, onClick } = this.props;

        return (
            <div className={style.gohome} onClick={onClick} style={{ ...styles }}>
                返回首页
            </div>
        );
    }
}

export default GoHome;
